// extracted by mini-css-extract-plugin
export default {"campaignSection":"CampaignPage_campaignSection__81GAA"};